// Подписка страницы на изменения (plugins/realtime.client.ts). handler вызывается не чаще раза в
// delay мс и откладывается, пока пользователь печатает (фокус в поле ввода), — иначе свежие
// данные стёрли бы недописанный текст. Отписка — автоматически при уходе со страницы.
type Kind = 'tender' | 'task' | 'notification'

function isTyping(): boolean {
  const el = document.activeElement as HTMLElement | null
  if (!el) return false
  return el.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName)
}

export function useRealtime(kind: Kind, handler: (ids: (number | null)[]) => void, opts: { delay?: number; filter?: (id: number | null) => boolean } = {}) {
  if (import.meta.server) return
  const { $realtime } = useNuxtApp() as any
  if (!$realtime) return
  const delay = opts.delay ?? 800
  let timer: ReturnType<typeof setTimeout> | undefined
  let collected = new Set<number | null>()

  const run = () => {
    if (isTyping()) {
      // Дождаться, пока пользователь закончит ввод
      document.addEventListener('focusout', () => setTimeout(run, 300), { once: true })
      return
    }
    if (!collected.size) return
    const ids = [...collected]
    collected = new Set()
    handler(ids)
  }

  const off = $realtime.on(kind, (ids: (number | null)[]) => {
    const relevant = opts.filter ? ids.filter(opts.filter) : ids
    if (!relevant.length) return
    relevant.forEach(id => collected.add(id))
    clearTimeout(timer)
    timer = setTimeout(run, delay)
  })

  onBeforeUnmount(() => {
    clearTimeout(timer)
    off()
  })
}
